module.exports = __webpack_public_path__ + "static/img/brushes.39c3bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brushes.png
// module id = 165
// module chunks = 2